import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import routeVariants from "../../assets/animates/routeVariants";
import Footer from "../global/Footer";
import NavbarBottom from "../global/NavbarBottom";
import companyHero from "../../assets/images/company/company-hero.png";
import VisionMission from "../../assets/images/company/sứ-mệnh.png";
import VisionVision from "../../assets/images/company/tầm-nhìn.png";
import VisionValues from "../../assets/images/company/giá-trị-cốt-lõi.png";
import TrustLegal from "../../assets/images/landing/benefits/pháp-lý.png";
import TrustSecurity from "../../assets/images/company/bảo-mật-và-phân-quyền.png";
import TrustAudit from "../../assets/images/company/lưu-vết-và-bằng-chứng.png";
import TrustUpdate from "../../assets/images/company/cập-nhật-và-cải-tiến.png";
import UspSign from "../../assets/images/landing/security/ecosystem/ký-số.png";
import UspWorkflow from "../../assets/images/company/tự-động-luồng-công-việc.png";
import UspRbac from "../../assets/images/company/bảo-mật-và-phân-quyền-sâu.png";
import UspHrm from "../../assets/images/company/kết-nối-HRM.png";

const VISION = [
  { key: "mission", image: VisionMission },
  { key: "vision", image: VisionVision },
  { key: "values", image: VisionValues, list: ["v1", "v2", "v3", "v4", "v5"] },
];

const TRUST = [
  { key: "c1", image: TrustLegal },
  { key: "c2", image: TrustSecurity },
  { key: "c3", image: TrustAudit },
  { key: "c4", image: TrustUpdate },
];

const USP = [
  { key: "c1", image: UspSign },
  { key: "c2", image: UspWorkflow },
  { key: "c3", image: UspRbac },
  { key: "c4", image: UspHrm },
];

const CompanyContent = () => {
  const { t, i18n } = useTranslation();
  const portalLogin = `https://gopaperless.mobile-id.vn/workflow/portal/login?language=${
    i18n.language || "vi"
  }`;

  return (
    <motion.div
      variants={routeVariants}
      initial="initial"
      animate="final"
      id="content"
      className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 bg-color-main no-transform"
    >
      <section className="company-hero pt-73">
        <div className="container px-md-0">
          <div className="company-hero-grid">
            <div>
              <span className="company-hero-badge">
                {t("company-page.hero.badge")}
              </span>
              <h1>
                {t("company-page.hero.title-1")}
                <br />
                <span className="company-hero-yl">
                  {t("company-page.hero.title-2")}
                </span>
              </h1>
              <p>{t("company-page.hero.desc")}</p>
              <a
                className="btn-secondary background-size-none"
                href={portalLogin}
                target="_blank"
                rel="noreferrer"
              >
                {t("company-page.hero.cta")} →
              </a>
            </div>
            <div className="company-hero-art">
              <img src={companyHero} alt={t("company-page.hero.img-alt")} />
            </div>
          </div>
        </div>
      </section>

      <section className="company-vision">
        <div className="container px-md-0">
          <div className="company-vision-grid">
            {VISION.map((item) => (
              <article key={item.key} className="company-v-card">
                <div className="company-card-ico">
                  <img
                    src={item.image}
                    alt={t(`company-page.vision.${item.key}.title`)}
                  />
                </div>
                <h3>{t(`company-page.vision.${item.key}.title`)}</h3>
                {item.list ? (
                  <ul>
                    {item.list.map((v) => (
                      <li key={v}>
                        {t(`company-page.vision.values.${v}`)}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>{t(`company-page.vision.${item.key}.desc`)}</p>
                )}
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="company-video">
        <div className="container px-md-0">
          <h2>{t("company-page.video.title")}</h2>
          <p className="company-lead">{t("company-page.video.lead")}</p>
          <div className="company-video-frame">
            <iframe
              src="https://www.youtube.com/embed/CgvmfcTjLSo"
              title={t("company-page.video.iframe-title")}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
        </div>
      </section>

      <section className="company-trust">
        <div className="container px-md-0">
          <div className="company-sec-head">
            <h2>{t("company-page.trust.title")}</h2>
            <Link className="company-more" to="/qa">
              {t("company-page.trust.more")} →
            </Link>
          </div>
          <p className="company-lead">{t("company-page.trust.lead")}</p>
          <div className="company-trust-grid">
            {TRUST.map((item) => (
              <article key={item.key} className="company-t-card">
                <div className="company-card-ico">
                  <img
                    src={item.image}
                    alt={t(`company-page.trust.${item.key}.title`)}
                  />
                </div>
                <h3>{t(`company-page.trust.${item.key}.title`)}</h3>
                <p>{t(`company-page.trust.${item.key}.desc`)}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="company-usp">
        <div className="container px-md-0">
          <div className="company-sec-head">
            <h2>{t("company-page.usp.title")}</h2>
            <Link className="company-more" to="/digital-signature">
              {t("company-page.usp.more")} →
            </Link>
          </div>
          <div className="company-usp-grid">
            {USP.map((item) => (
              <article key={item.key} className="company-u-card">
                <div className="company-card-ico">
                  <img
                    src={item.image}
                    alt={t(`company-page.usp.${item.key}.title`)}
                  />
                </div>
                <h3>{t(`company-page.usp.${item.key}.title`)}</h3>
                <p>{t(`company-page.usp.${item.key}.desc`)}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="company-cta">
        <div className="container px-md-0">
          <div className="home-cta-banner">
            <div className="home-cta-left">
              <div className="home-cta-copy">
                <h2>{t("home-page.home-content.cta.title")}</h2>
                <p>{t("home-page.home-content.cta.desc")}</p>
              </div>
              <a
                className="btn-primary home-cta-btn"
                href={portalLogin}
                target="_blank"
                rel="noreferrer"
              >
                {t("home-page.home-content.cta.button")}
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <NavbarBottom />
    </motion.div>
  );
};

export default CompanyContent;
